export const questions = {
    easy: [
      {
        text: "Does Pyae Sone enjoy brunch?",
        answers: [
          { text: "Yes", isCorrect: true },
          { text: "No", isCorrect: false },
        ],
      },
      {
        text: "Where is Pyae Sone's Hometown?",
        answers: [
          { text: "Yangon, Myanmar ", isCorrect: true },
          { text: "Mandalay, Myanmar", isCorrect: false },
          { text: "Parramatta, NSW", isCorrect: false },
          { text: "Naypyidaw, Myanmar", isCorrect: false },
        ],
      },
      {
        text: "Which sports mentioned below is Pyae Sone's favorite?",
        answers: [
          { text: "Golf", isCorrect: false },
          { text: "Badminton", isCorrect: false },
          { text: "Football", isCorrect: true },
          { text: "Tennis", isCorrect: false },
        ],
      },
      {
        text: "What would Pyae Sone want after a long day?",
        answers: [
          { text: "Regular Chicken HSP", isCorrect: true },
          { text: "Ayam Penyet with Green Chilli Sauce", isCorrect: false },
          { text: "Large Quarter Pounder with 24 chicken nuggets along with aioli sauce", isCorrect: false },
          { text: "20 Lemon and Herb Chicken Wings with Ranch Sauce", isCorrect: false },
        ],
      },
      {
        text: "What is Pyae Sone's favorite color?",
        answers: [
          { text: "White", isCorrect: false },
          { text: "Red", isCorrect: false },
          { text: "Blue", isCorrect: false },
          { text: "Black", isCorrect: true },
        ],
      },
      {
        text: "Does Pyae Sone more of a dog person or cat person?",
        answers: [
          { text: "cat", isCorrect: false },
          { text: "dog", isCorrect: false },
          { text: "neither, he a stone-cold bloke", isCorrect: true },
        ],
      },
      {
        text: "Does Pyae Sone enjoy pineapple on pizza?",
        answers: [
          { text: "Yes", isCorrect: true },
          { text: "No", isCorrect: false },
        ],
      },
      {
        text: "What’s Pyae Sone’s star sign?",
        answers: [
          { text: "Sagittarius", isCorrect: true },
          { text: "Capricorn", isCorrect: false },
          { text: "Virgo", isCorrect: false },
          { text: "Cancer", isCorrect: false },
        ],
      },
      {
        text: "How many aunts and uncles in total does Pyae Sone have?",
        answers: [
          { text: "3", isCorrect: false },
          { text: "5", isCorrect: true },
          { text: "7", isCorrect: false },
          { text: "12", isCorrect: false },
        ],
      },
      {
        text: "What is Pyae Sone's major and main interest?",
        answers: [
          { text: "Computer Engineering, Machine Learning", isCorrect: false },
          { text: "Computer Science, Machine Learning", isCorrect: false },
          { text: "Computer Engineering, Web Development with AI", isCorrect: true },
          { text: "Commerce and CompSci, Machine Learning and AI", isCorrect: false },
        ],
      },

    ],





    normal: [
      {
        text: "What's Pyae Sone's favorite album of 2026?",
        answers: [
          { text: "OCTANE by Don Toliver", isCorrect: true },
          { text: "BULLY by Kanye West", isCorrect: false },
          { text: "All three albums of Drake", isCorrect: false },
          { text: "Deadbeat by Tame Impala", isCorrect: false },
        ],
      },
      {
        text: "What’s the name of the first album Pyae Sone ever obsessed over?",
        answers: [
          { text: "Utopia by Travis Scott", isCorrect: true },
          { text: "Vultures by Kanye West", isCorrect: false },
          { text: "For all the dogs by Drake", isCorrect: false },
          { text: "After Hours by the Weekend", isCorrect: false },
        ],
      },
      {
        text: "What kind of football fan is Pyae Sone?",
        answers: [
          { text: "Plastic Fan", isCorrect: false },
          { text: "Hardcore Man United Supporter", isCorrect: false },
          { text: "Neutral, just a football admirer", isCorrect: true },
          { text: "Performative, bro knows nothing about football", isCorrect: false },
        ],
      },
      {
        text: "How many shoes does Pyae Sone have? (excluding badminton shoes and football cleats)",
        answers: [
          { text: "5", isCorrect: false },
          { text: "7", isCorrect: false },
          { text: "9", isCorrect: false },
          { text: "11", isCorrect: true },
        ],
      },
      {
        text: "Where does Pyae Sone's little sister currently studying her A levels?",
        answers: [
          { text: "Cambridge, UK", isCorrect: true },
          { text: "Oxford, UK", isCorrect: false },
          { text: "Paramatta, NSW, Australia", isCorrect: false },
          { text: "London , UK", isCorrect: false },
        ],
      },
      {
        text: "Who was Pyae Sone's Top Artist in Spotify Wrapped 23?",
        answers: [
          { text: "Juice Wrld", isCorrect: true },
          { text: "Kanye West", isCorrect: false },
          { text: "Kendrick", isCorrect: false },
          { text: "Drake", isCorrect: false },
        ],
      },
      {
        text: "How many cameras does Pyae Sone Have?",
        answers: [
          { text: "4", isCorrect: false },
          { text: "7", isCorrect: true },
          { text: "9", isCorrect: false },
          { text: "10", isCorrect: false },
        ],
      },
      {
        text: "What is Pyae Sone's ideal day?",
        answers: [
          { text: "Stay in, binge some TV shows and order in takeout food", isCorrect: false },
          { text: "Brunch ➡️ Gym ➡️ Sunset ➡️ Good Dinner", isCorrect: true },
          { text: "Sunrise ➡️ brunch ➡️ badminton ➡️ Good Dinner", isCorrect: false },
          { text: "Sunrise ➡️ nap ➡️ gym ➡️ steak, eggs and avos", isCorrect: false },
        ],
      },
      {
        text: "What is Pyae Sone's usual coffee order?",
        answers: [
          { text: "Flat White with skim milk and no sugar", isCorrect: true },
          { text: "Iced Latte with two sugar", isCorrect: false },
          { text: "Iced Long Black", isCorrect: false },
          { text: "Mocha with skim milk", isCorrect: false },
          { text: "No, he perfomative and drink matcha latte", isCorrect: false },
        ],
      },
      {
        text: "Which game did Pyae Sone spend most time on?",
        answers: [
          { text: "Dota2", isCorrect: true },
          { text: "CSGO", isCorrect: false },
          { text: "Call of Duty: Cold Wars", isCorrect: false },
          { text: "FIFA", isCorrect: false },
        ],
      },
      {
        text: "Two Truths, One Lie! Which one is the lie?",
        answers: [
          { text: "Java is my favorite Programming Language", isCorrect: true },
          { text: "I know how to swim.", isCorrect: false },
          { text: "I secretly like to wear glasses while I study alone.", isCorrect: false },
        ],
      },
      {
        text: "What sitcom is Pyae Sone's all time favorite?",
        answers: [
          { text: "Friends", isCorrect: false },
          { text: "How I met your Mother", isCorrect: true },
          { text: "Seinfeld", isCorrect: false },
          { text: "The Big Bang Theory", isCorrect: false },
        ],
      }

    ],







    hard: [
      {
        text: "How much is Pyae Sone's rating on Chess.com?",
        answers: [
          { text: "650", isCorrect: false },
          { text: "800", isCorrect: false },
          { text: "950", isCorrect: true },
          { text: "1150", isCorrect: false },
        ],
      },
      {
        text: "Which camera below is Pyae Sone's favorite to shoot with?",
        answers: [
          { text: "Digital: Instax Mini Evo", isCorrect: false },
          { text: "Film: Olympus Mju Zoom105", isCorrect: false },
          { text: "Digital: Canon 800D with 18-35mm lens", isCorrect: false },
          { text: "Film: Olympus Trip 10", isCorrect: false },
          { text: "Digital: Fujfilm XT-1 with 28mm lens", isCorrect: true },
        ],
      },
      {
        text: "What is Pyae Sone's Favorite movie of all time?",
        answers: [
          { text: "Avengers' Infinity War and Endgame", isCorrect: false },
          { text: "The Secret Life of Walter Mitty", isCorrect: true },
          { text: "La La Land", isCorrect: false },
          { text: "Three Idiots", isCorrect: false },
        ],
      },
      {
        text: "What is Pyae Sone's best words per minute(WPM)?",
        answers: [
          { text: "85", isCorrect: false },
          { text: "87", isCorrect: true },
          { text: "93", isCorrect: false },
          { text: "98", isCorrect: false },
        ],
      },
      {
        text: "Which FIFA Pyae Sone has spent most time on?",
        answers: [
          { text: "FIFA 20", isCorrect: false },
          { text: "FIFA 21", isCorrect: true },
          { text: "FIFA 24", isCorrect: false },
          { text: "FIFA 18", isCorrect: false },
        ],
      },
      {
        text: "What is the longest Pyae Sone has ever stayed awake?",
        answers: [
          { text: "24 hours", isCorrect: false },
          { text: "48 hours", isCorrect: false },
          { text: "72 hours", isCorrect: true },
          { text: "4 days", isCorrect: false },
        ],
      },
      {
        text: "Which playlist in 2024 Pyae Sone had on repeat?",
        answers: [
          { text: "Hardstone Psycho by Don Toliver", isCorrect: true },
          { text: "Vultures 1 and 2 by Kanye West", isCorrect: false },
          { text: "We Still Don't Trust You by Metro Boomin and Future", isCorrect: false },
          { text: "Chromakopia by Tyler, the creator", isCorrect: false },
        ],
      },
      {
        text: "What color switch of mechanical keypress is Pyae Sone's Favorite?",
        answers: [
          { text: "Red", isCorrect: false },
          { text: "Blue", isCorrect: false },
          { text: "Brown", isCorrect: false },
          { text: "Trick question, he likes membrane keys", isCorrect: false },
          { text: "Purple", isCorrect: true },
        ],
      },
      {
        text: "What iPhone app would Pyae Sone cannot stay without?",
        answers: [
          { text: "Gallery", isCorrect: false },
          { text: "MyFitnessPal", isCorrect: true },
          { text: "Instagram", isCorrect: false },
          { text: "Chess.com", isCorrect: false },
        ],
      },
      {
        text: "What is Pyae Sone's dream watch in 2026?",
        answers: [
          { text: "Rolex Submariner", isCorrect: false },
          { text: "Audemars Piguet (AP) Royal Oak", isCorrect: false },
          { text: "Tudor Black Bay 58", isCorrect: true },
          { text: "Patek Phillipe Annual Calendar", isCorrect: false },
        ],
      },

    ],
  };
